import { DataModel } from './data-model.model';
import { UserInfo } from './user-info.model';
import { WorkflowSpecificationModel } from './workflow-specification';

export class WorkflowSubmission extends DataModel {
    workflowId?: string;
    producerId?: string;
    producerEmail?: string;
    producer?: string;
    workflowTitle?: string;
    workflowSummary?: string;
    createdAt?: string; // TODO: convert to date
    modifiedAt?: string; // TODO: convert to date
    state?: string; // TODO: declare type
    commentToReviewer?: string;
    commentToProducer?: string;
    rawSpecificationJson?: WorkflowSpecificationModel = new WorkflowSpecificationModel();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    workflow?: any;

    /* undefined at backend */
    author?: UserInfo;
}
